export default __webpack_public_path__ + "static/media/tiqassist_logo.20c7e6cd.svg";